import { EntityStore } from './entity-store'

type OutletsStore = EntityStore<'outlets'>

/**
 * Stores information on the retailer's outlets.
 */
export const outletsStore: OutletsStore = new EntityStore({
  entityStoreName: 'outlets',
})
